const USER_ROLES = {
    SUPER_ADMIN              : 'superAdmin',
    ADMIN                    : 'admin',
    SUPPORT                  : 'support',
    AGENT                    : 'agent',
    COURIER_ADMIN            : 'courierAdmin',
    COURIER_AGENT            : 'courierAgent',
    HOST_ADMIN               : 'hostAdmin',
    HOST_AGENT               : 'hostAgent',
    TRAVEL_COMPANY_ADMIN     : 'travelCompanyAdmin',
    TRAVEL_COMPANY_AGENT     : 'travelCompanyAgent',
    USER                     : 'user',
    HANDLING_COMPANY_AGENT   : 'handlingCompanyAgent',
    HANDLING_COMPANY_MANAGER : 'handlingCompanyManager',
    HANDLING_COMPANY_OPERATOR: 'handlingCompanyOperator',
    HANDLING_COMPANY_OBSERVER: 'handlingCompanyObserver',
} as const

export type UserRoles = typeof USER_ROLES;

export default USER_ROLES;
